<template lang="pug">
.app-filters(v-if="!hiddenFilterGroups.includes(group.id)")
	header.app-filters__header(@click="toggle('open')")
		span.app-filters__title {{group.name}}
		button.app-filters__toggle(:class="{open}" type="button" :aria-label="filterToggleLabel")
	TransitionExpand
		.app-filters__search(v-if="open && group.filters.length >= config.filterSearchMinimumCount" key="searcher")
			.app-filters__search-inner
				span.blue-icon-search_medium
				label.app-filters__search-label(:for="group.id") {{ config.filterSearchPrefix }} {{ group.name }}
				input.app-filters__search-input(v-model="search" :id="group.id" type="text" :placeholder="`${config.filterSearchPrefix} ${group.name}`")
		AppFilter(
			v-for="(filter, i) in filters"
			v-if="open && (expanded || i < config.filterTruncateCount)"
			:key="'f1'+filter.id"
			:executeSearch="executeSearch"
			:filter="filter"
			:setFilterValue="setFilterValue")
		button.app-filters__expand(
			v-if="open && filters.length > config.filterTruncateCount"
			@click="toggle('expanded')"
			:class="{expanded}"
			key="expander"
			type="button")
				span View {{expanded ? 'Less' : 'All'}}
</template>
		
<script>
import AppFilter from './Filter.vue';
import TransitionExpand from '../../global/transitions/Expand.vue'

export default {
	name: "AppFilters",
        props: ['group', 'initiallyExpanded', 'setFilterValue', 'executeSearch', 'showZeroResultFilters' ],
	components: { TransitionExpand, AppFilter },
	data() {
		return {
			open: this.initiallyExpanded,
			expanded: false,
			search: ''
		};
	},
	computed: {
		filterItems() {
			let sortedFilters;
			// We want to sort facets alphabetically when the filter count is not being displayed, and
			// right now, based on BE-only logic, the count is being hidden when it's an LRL page.
			if (this.config.isLrlPage) {
				sortedFilters = this.group.filters.sort((a, b) =>  {
					// Dates should still be newest to oldest
					if (!isNaN(parseInt(a.value)) && !isNaN(parseInt(b.value))) {
						return parseInt(b.value) - parseInt(a.value);
					}
					return a.value.localeCompare(b.value);
				});
			} else sortedFilters = this.group.filters;
			if (this.showZeroResultFilters) {
				return sortedFilters.filter(item => item.count >= 0 || item.selected);
			} else {
				return sortedFilters.filter(item => item.count > 0 || item.selected);
			}
		},
		filters() {
			return this.filterItems.filter(f => {
				return f.value.toLowerCase().trim().includes(this.search.toLowerCase().trim())
			});
		},
		filterToggleLabel() {
			let keyword = this.open ? 'Hide' : 'Show';
			return keyword + ' filter options for ' + this.group.name;
		},
		hiddenFilterGroups() {
			return !!this.$root.config.hiddenFilterGroups ? this.$root.config.hiddenFilterGroups.split(",").map(str => str.trim()) : [];
		}
	},
	methods: {
		toggle(state) {
			this[state] = !this[state];
		}
	},
	created() {},
	mounted() {},
};
</script>

<style lang="scss">
.app-filters {
	&__expand,
	&__toggle {
		appearance: none;
		all: unset;
		display: flex;
		flex: 0 0 auto;
	}

	&__toggle {
		padding: 0.5rem;
		align-self: center;

		&.open {
			&::before {
				transform: rotate(-45deg);
			}
		}

		&::before {
			content: '';
			flex: 0 0 0.5rem;
			height: 0.5rem;
			width: 0.5rem;
			border-top: 1px solid $gray;
			border-right: 1px solid $gray;
			transition: 0.2s ease;
			transform: rotate(135deg);
		}
	}

	&__expand {
		@include fluid(font-size, 0.75rem, 0.875rem);
		display: flex;
		gap: 0.5rem;
		align-items: center;
		color: var(--link-color, $red);
		font-weight: 700;
		text-decoration: none;
		transition: 0.2s ease;

		&::before {
			content: '+';
			margin-top: 0.5rem;
		}

		span {
			transition: 0.2s ease;
			margin-top: 0.5rem;
		}

		&.expanded {
			&::before {
				content: '\2013'
			}
		}

		&:hover {
			span {
				transform: translateX(0.5rem);
			}
		}
	}
}
</style>

<style lang="scss" scoped>
.app-filters {
	display: flex;
	flex-direction: column;
	padding: 1rem 0;
	border-top: 1px solid $lightGray;
	cursor: pointer;

	&:last-child {
		border-bottom: 1px solid $lightGray;
	}
		
	.page--ORG & {
		padding: 1.75rem 0.875rem;
	}

	&__header {
		display: flex;
		justify-content: space-between;
		cursor: pointer;
	}

	&__search {
		display: flex;
		flex-direction: column;

		&-inner {
			display: flex;
			align-items: center;
			gap: 0.5rem;
			line-height: 1;
			border: 1px solid $mediumGray;
			padding: 0.5rem;
			border-radius: 4px;
			margin: 0.75rem 0;

			&:focus-within {
				border-color: var(--focus-color, $red);
			}
			span:first-child {
				order: 2;
			}
		
			.page--ORG & {
				padding: 0.75rem 0.625rem;
			}
		}

		&-label {
			@include hideVisually;
		}

		&-input {
			appearance: none;
			border: none;
			background: transparent;
			border-radius: 0;
			width: auto;
			flex: 1 1 100%;
			font-size: 0.875rem;

			&:focus {
				box-shadow: none !important;
			}
		}
	}

	&__title {
		color: var(--link-color, $blue);
		font-weight: 700;
		font-size: 1rem;
		
		.page--ORG & {
			text-transform: uppercase;
		}
	}

}
</style>